import { inr } from "../lib/api";

const autoAbout = (p, catName) => {
  const off = p.mrp > p.price ? Math.round((1 - p.price / p.mrp) * 100) : 0;
  const specs = Object.entries(p.specs || {}).filter(([k]) => !["Brand", "Delivery", "Type"].includes(k) && !(p.highlights || []).some((h) => h.startsWith(k))).slice(0, 4).map(([k, v]) => `${k.toLowerCase()}: ${v}`);
  const hl = (p.highlights || []).filter((h) => !(p.description || "").includes(h)).slice(0, 3);
  return [
    `${p.title}${p.brand ? ` from ${p.brand}` : ""} is listed in ${p.subcategory ? `${p.subcategory}, part of our ` : ""}${catName || "shop"} range on EAZYSHOPY. ${p.description || ""}`.trim(),
    `It is available for ${inr(p.price)}${off > 0 ? `, ${off}% below the MRP of ${inr(p.mrp)}` : ""}, inclusive of GST.${p.rating ? ` Shoppers rate it ${p.rating} out of 5 across ${p.reviews_count || 0} ratings.` : ""}`,
    hl.length ? `Key points to know: ${hl.join("; ")}.` : "",
    specs.length ? `Main specifications include ${specs.join(", ")}.` : "",
    `Sold by ${p.seller_name || "a verified seller"}${p.return_days ? ` with a ${p.return_days}-day return window` : ""}. Enter your PIN code above to check delivery to your area, pay with cash on delivery and track your order live until it reaches you.`,
  ].filter(Boolean);
};

export default function ProductAbout({ p, catName }) {
  const paras = p.about ? p.about.split(/\n+/).filter(Boolean) : autoAbout(p, catName);
  return (
    <section className="space-y-3 text-sm text-slate-300 leading-relaxed" data-testid="product-about">
      <h2 className="text-base md:text-lg font-bold text-slate-100">About {p.title}</h2>
      {paras.map((t, i) => <p key={i}>{t}</p>)}
    </section>
  );
}
